import React from 'react';
import {useWatch} from "react-hook-form";
import ShowField from "v4/components/form/ShowField/ShowField";

export default function AttributeShowField({id, name, type, attr, label}) {
    const value = useWatch({name});

    return (
        <ShowField id={id} type={type} name={name} value={value} attr={attr} label={label}/>
    );
}
